import { TabBookingAbstract } from '@/components/Cargo/Job/booking/tabs/tabBookingAbstract.js'
import { Company } from '@/class/model/mdm/Company'
import { AirExportJob } from '@/class/model/booking/AirExportJob'
import { User } from '@/class/model/sys/User'
import { Office } from '@/class/model/sys/Office'
import { JobUtils } from '@/class/cargo/model/utils/JobUtils'
import * as NumberUtils from '@/utils/NumberUtils'
import * as CargoDocConsts from '@/class/cargo/model/parameters/CargoDocConsts'
import * as AirExportConstants from '@/class/cargo/model/parameters/AirExportConstants'
import LocalStorageUtils from '@/utils/localStorageUtils'
import { AirPort } from '@/class/model/mdm/AirPort'
import { IataPrice } from '@/class/model/sys/IataPrice'
import { AirLine } from '@/class/model/sys/AirLine'
import * as BookingTerm from '@/class/cargo/model/parameters/BookingTerm'
import { changeMAWBNo } from '@/api/AirExport/airExportJob'
import { getUserInfo } from '@/utils/auth'
import { queryMAWBInfo } from '@/api/partner/mawbInfo'
import { AirExportUtils } from '@/class/cargo/model/utils/AirExportUtils'
import $store from '@/store'
import { AirCargoDocUtil } from '@/class/cargo/model/utils/AirCargoDocUtil'
import * as RateUtil from '@/class/cargo/model/utils/RateUtil'
import { getObjectByCache } from '@/utils/basicDataCache'
import { basicCacheKeys } from '@/utils/cacheConfig'
import { queryAirlineProductDownList } from '@/api/booking/airlineProduct'
import { IMPERIAL_1 } from '@/class/cargo/model/parameters/SystemConstants'

export class TabMasterHP extends TabBookingAbstract {
  constructor(view) {
    super(view)
    this.$t = this.view.$t
    this.removedSubJobs = []
    this.removedSubJobKeys = []
    this.removeMbls = []
  }

  get job() {
    return this.view.job
  }
  set job(job) {
    this.view.job = job
  }

  // 初始化
  init() {
    this.trustFromEditSales = Number(this.config.get('TrustFromEditSales')) === 1
    this.isSpecifiedSalesBusiness = Number(this.config.get('IsSpecifiedSalesBusiness')) === 1
    this.branchOfficeCheck = Number(this.config.get('departmentSalesOfficeCheck')) === 1
    this.cWeightIsCeil = Number(this.config.get('AEcWeightCeil')) // 计费重量是否取整
    this.refSelDesignationAgent = Number(this.config.get('refSelDesignationAgent')) === 1
    this.canChangeSalesOfJob = Number(this.config.get('canChangeSalesOfJob')) === 1
    this.salesOfficeCheck = Number(this.config.get('SalesOfficeCheck')) === 1
    this.view.isAddUserDefinedRoles = Number(this.config.get('IsAddUserDefinedRoles')) === 1
    this.airCargoEnglishName = Number(this.config.get('airCargoEnglishName'))
    this.airCargoMark = Number(this.config.get('airCargoMark'))
    this.view.isZY = String(this.config.get('ToExoSystem')) === 'zy' // 显示中邮选项
    // 初始化 航线产品下拉列表
    queryAirlineProductDownList({ containVoyage: false, branchId: $store.getters.currentOfficeId }).then(res => {
      this.view.airlineProductDownList = res.data
    })
    JobUtils.initImperialSetting().then(r => {
      this.view.showImperialButton = r
    })
    JobUtils.initImperialData(IMPERIAL_1.code).then(r => {
      this.view.isOpenImperial = r
      this.view.originalImperial = r
    })
  }
  // 更新页面显示(此方法中包含了原来的fillView方法以及changeJob方法)
  async fillView() { //
    const job = this.job
    if (!job) return
    await this.checkMbl() // 此处一定要等待，否则提单数据不对
    if (this.salesOfficeCheck) {
      this.view.salesList = await User.getUsersByPrivilegeDetail('role', 'sales', null, $store.getters.currentOfficeId, true)
    } else {
      this.view.salesList = await User.getUsersByPrivilegeDetail('role', 'sales', null, null, true)
    }
    if (this.IsSpecifiedSalesBusiness && (!this.view.salesList || this.view.salesList.length === 0)) {
      this.view.salesPrompt = this.view.$t('SeaExport.PleaseMaintainTheCorrespondingSalesInThePartner')
    } else {
      if (!this.view.viewStatus) {
        this.view.salesPrompt = this.view.$t('SeaExport.ClickSpaceToDropDownOptions')
      }
    }
    if (!job.uuid && Boolean(LocalStorageUtils.getConfiguration('COPY_JOB'))) {
      // 复制业务时校验新业务岗位角色在当前分公司是否有对应的岗位权限
      LocalStorageUtils.removeConfiguration('COPY_JOB')
      if (job.dc > 0) {
        this.view.$nextTick(() => {
          this.view.$refs.dc.executeAfterLoad(data => {
            if (JobUtils.checkUserRolePrivilege(data, job.dc)) {
              job.dc = 0
              job.dcDepartment = 0
            }
          })
        })
      }
    }
    this.setCargoSize()
    if (!job.uuid) {
      if (!job.csr) {
        job.csr = getUserInfo().userId
      }
      this.changeMAWBInfo(job.carrierId)
      JobUtils.matchUserPortConfig(this.view, job)
      JobUtils.matchRegionWarehouseMappingConfig(job, null, false, null, this.context.modifiedData, true)
    } else {
      JobUtils.matchUserPortConfig(this.view, job, false, null, { keepOriginValue: true })
    }
    this.checkButtonSate()
    this.updateLoading3Code()
    this.updateDestination3Code()
    this.loadCompanyOffice()
  }
  // CARGO-7636 6712翘楚：主票添加货物尺寸字段 设置主票货物尺寸
  setCargoSize() {
    this.view.measurements = ''
    if (this.job && this.job.masterFlag && this.job.lclSlaves) {
      const childList = this.job.lclSlaves
      this.localeCompareHandler(childList)
      let masterMeasurements = ''
      for (const childJob of childList) {
        if (childJob.measurements) {
          masterMeasurements += childJob.measurements + '\n'
        }
      }
      this.view.measurements = masterMeasurements
    }
  }
  // 倒序排列
  localeCompareHandler(list) {
    return list.sort((a, b) => Number(a.jobNo5) - Number(b.jobNo5))
  }
  // 检查提单
  async checkMbl() {
    this.view.cargoDoc = await new AirExportJob(this.job).getCargoDoc(CargoDocConsts.MAWB, true)
    if (this.view.cargoDoc && this.view.cargoDoc.uuid) {
      this.view.cargoDoc.dvforCustoms = 'NCV'
    }
  }
  // 起运港
  async loadingPortChangeHandler(data) {
    const job = this.job
    job.loadingPortCode = data.value
    this.syncJobPortCargoDoc()
    this.updateLoading3Code()
  }
  // 把Job上的港口信息同步到CargoDoc上
  async syncJobPortCargoDoc() {
    const job = this.job
    const airport = await AirPort.getAirportByCode(job.loadingPortCode)
    this.view.cargoDoc.signPlaceBL = this.getCity(airport)
    this.view.cargoDoc.airportOfDeparture = !airport ? '' : airport.englishName
    const airportDes = await AirPort.getAirportByCode(job.destinationPortCode)
    this.view.cargoDoc.airportOfDestination = !airportDes ? '' : airportDes.englishName
  }
  // 目的港
  async destinationPortCodeChange(data) {
    this.job.destinationPortCode = data.value
    this.job.dischargingPortCode = data.value
    const port = await AirPort.getAirportByCode(this.job.destinationPortCode)
    this.view.cargoDoc.podTo = this.job.destinationPortCode
    // 如果最终交货地没有值时，目的港改变时，把目的港的值赋值给最终交货地
    // 如果最终交货地有值时，目的港改变时，不要把目的港的值赋值给最终交货地
    if (!this.job.destinationPlace) {
      this.job.destinationPlace = port ? port.englishName : ''
    }
    this.syncJobPortCargoDoc()
    this.updateDestination3Code()
    JobUtils.matchUserPortConfig(this.view, this.job)
    JobUtils.matchRegionWarehouseMappingConfig(this.job, null, false, null, this.context.modifiedData)
  }
  // 加载销售分公司
  async loadCompanyOffice() {
    const office = await Office.getOfficeById(this.job.salesOffice)
    if (office) {
      this.view.txtSalesOffice = office.chineseName
    } else {
      this.view.txtSalesOffice = ''
    }
  }
  // 检查提单
  async changeMAWBInfo(cmpIdx = 0) {
    const carrier = await Company.getCompanyById(cmpIdx > 0 ? cmpIdx : this.job.carrierId)
    if (!carrier) {
      this.job.planner = 0
    }
    let airline = null
    if (this.view.cargoDoc && this.view.cargoDoc.state < 2) { airline = this.view.cargoDoc.carrierBy = !carrier ? '' : carrier.shortName }
    if (airline) {
      await queryMAWBInfo({ airline: airline, branchId: $store.getters.currentOfficeId }).then(async res => {
        if (res && res.data && res.data.length > 0) {
          if (!this.job.uuid) {
            this.changeMAWBInfoCommon(res.data)
          } else {
            this.view.mawbinfoDatas = res.data
            this.changeMAWBInfoCommonTips(this.view.mawbinfoDatas)
          }
        }
      })
    }
  }
  // 目的港代理
  async destinationAgentChangeHandler(data) {
    const job = this.job
    job.destinationAgent = data.value
    this.loadOverseaAgentResultHandler()
    this.syncDocHandlingInfo()
    JobUtils.matchUserPortConfig(this.view, job)
  }
  // 加载海外代理维护信息
  async loadOverseaAgentResultHandler() {
    const destCmp = await Company.getCompanyById(this.job.destinationAgent)
    if (destCmp) {
      const overseaAgentDetail = await new Company(destCmp).getOverseaAgentDetail()
      if (overseaAgentDetail) {
        this.view.cargoDoc.consigneeLine1 = overseaAgentDetail.airAddressLine1
        this.view.cargoDoc.consigneeLine2 = overseaAgentDetail.airAddressLine2
        this.view.cargoDoc.consigneeLine3 = overseaAgentDetail.airAddressLine3
        this.view.cargoDoc.consigneeLine4 = overseaAgentDetail.airAddressLine4
        this.view.cargoDoc.consigneeLine5 = overseaAgentDetail.airAddressLine5
        this.view.cargoDoc.consigneeLine6 = overseaAgentDetail.airAddressLine6
        this.view.cargoDoc.consigneeLine7 = overseaAgentDetail.airAddressLine7
      }
    }
  }
  async weightCubAgeImperialChangeHandler(type) {
    if (['weightBooking', 'cubageBooking'].includes(type)) {
      if (type === 'weightBooking') {
        this.job.weightBooking = await JobUtils.calculateWeight(this.job.weightBookingImperial)
      }
      if (type === 'cubageBooking') {
        this.job.cubageBooking = await JobUtils.calculateCubAge(this.job.cubAgeBookingImperial)
      }
      await this.weightCubageChangeHandler(type)
      this.job.chargeWeightBookingImperial = await JobUtils.calculateWeight(this.job.chargeWeightBooking, true)
    }
    if (['weight', 'cubage'].includes(type)) {
      const cargoDoc = this.view.cargoDoc
      if (type === 'weight') {
        cargoDoc.weight = await JobUtils.calculateWeight(cargoDoc.weightImperial)
      }
      if (type === 'cubage') {
        cargoDoc.cubage = await JobUtils.calculateCubAge(cargoDoc.cubAgeImperial)
      }
      await this.weightCubageChangeHandler(type)
      cargoDoc.chargeWeightImperial = await JobUtils.calculateWeight(cargoDoc.cWeight, true)
    }
  }
  async doWeightCubAgeChangeHandler(type) {
    if (['weightBooking', 'cubageBooking'].includes(type)) {
      if (type === 'weightBooking') {
        this.job.weightBookingImperial = await JobUtils.calculateWeight(this.job.weightBooking, true)
      }
      if (type === 'cubageBooking') {
        this.job.cubAgeBookingImperial = await JobUtils.calculateCubAge(this.job.cubageBooking, true)
      }
      await this.weightCubageChangeHandler(type)
      this.job.chargeWeightBookingImperial = await JobUtils.calculateWeight(this.job.chargeWeightBooking, true)
    }
    if (['weight', 'cubage'].includes(type)) {
      const cargoDoc = this.view.cargoDoc
      if (type === 'weight') {
        cargoDoc.weightImperial = await JobUtils.calculateWeight(cargoDoc.weight, true)
      }
      if (type === 'cubage') {
        cargoDoc.cubAgeImperial = await JobUtils.calculateCubAge(cargoDoc.cubage, true)
      }
      await this.weightCubageChangeHandler(type)
      cargoDoc.chargeWeightImperial = await JobUtils.calculateWeight(cargoDoc.cWeight, true)
    }
  }
  // 重量体积变更函数
  async weightCubageChangeHandler(type = '') {
    const job = this.job
    if (!job) return
    const cargoDoc = this.view.cargoDoc
    if (type === 'weightActual' || type === 'cubageActual') {
      const weight = isNaN(this.job.weightActual) ? 0 : this.job.weightActual
      const cubage = isNaN(this.job.cubageActual) ? 0 : this.job.cubageActual
      if (cubage) {
        this.job.densityActual = NumberUtils.ToFixed2(weight / cubage, 3)
      } else {
        this.job.densityActual = 0
      }
    }
    switch (type) {
      case 'chargeWeightActual':
        job.cWeight = JobUtils.calcChargeWeight2(job.cWeight, true, this.cWeightIsCeil)
        job.cWeight = isNaN(job.cWeight) ? 0 : job.cWeight
        break

      case 'weightContract':
      case 'cubageContract':
        job.chargeWeight = JobUtils.calcChargeWeight(job.weightContract, job.cubageContract, true, this.cWeightIsCeil)
        job.chargeWeight = isNaN(job.chargeWeight) ? 0 : job.chargeWeight
        {
          const weight = isNaN(this.job.weightContract) ? 0 : this.job.weightContract
          const cubage = isNaN(this.job.cubageContract) ? 0 : this.job.cubageContract
          if (cubage) {
            this.job.densityContract = NumberUtils.ToFixed2(weight / cubage, 3)
          } else {
            this.job.densityContract = 0
          }
        }
        break

      case 'weightStation':
      case 'cubageStation':
        job.chargeWeightStation = JobUtils.calcChargeWeight(job.weightStation, job.cubageStation, true, this.cWeightIsCeil)
        job.chargeWeightStation = isNaN(job.chargeWeightStation) ? 0 : job.chargeWeightStation
        {
          const weight = isNaN(this.job.weightStation) ? 0 : this.job.weightStation
          const cubage = isNaN(this.job.cubageStation) ? 0 : this.job.cubageStation
          if (cubage) {
            this.job.densityStation = NumberUtils.ToFixed2(weight / cubage, 3)
          } else {
            this.job.densityStation = 0
          }
        }
        break

      case 'weightSigning':
      case 'cubageSigning':
        job.chargeWeightSigning = JobUtils.calcChargeWeight(job.weightSigning, job.cubageSigning, true, this.cWeightIsCeil)
        job.chargeWeightSigning = isNaN(job.chargeWeightSigning) ? 0 : job.chargeWeightSigning
        {
          const weight = isNaN(this.job.weightSigning) ? 0 : this.job.weightSigning
          const cubage = isNaN(this.job.cubageSigning) ? 0 : this.job.cubageSigning
          if (cubage) {
            this.job.densitySigning = NumberUtils.ToFixed2(weight / cubage, 3)
          } else {
            this.job.densitySigning = 0
          }
        }
        break

      case 'weightBooking':
      case 'cubageBooking':
        job.chargeWeightBooking = JobUtils.calcChargeWeight(job.weightBooking, job.cubageBooking, false)
        job.chargeWeightBooking = isNaN(job.chargeWeightBooking) ? 0 : job.chargeWeightBooking
        {
          const weight = isNaN(this.job.weightBooking) ? 0 : this.job.weightBooking
          const cubage = isNaN(this.job.cubageBooking) ? 0 : this.job.cubageBooking
          if (cubage) {
            this.job.densityBooking = NumberUtils.ToFixed2(weight / cubage, 3)
          } else {
            this.job.densityBooking = 0
          }
        }
        break

      case 'weight':
      case 'cubage':
        if (cargoDoc) {
          cargoDoc.cWeight = JobUtils.calcChargeWeight(cargoDoc.weight, cargoDoc.cubage, true, this.cWeightIsCeil)
          cargoDoc.cWeight = isNaN(cargoDoc.cWeight) ? 0 : cargoDoc.cWeight
          const weight = isNaN(cargoDoc.weight) ? 0 : cargoDoc.weight
          const cubage = isNaN(cargoDoc.cubage) ? 0 : cargoDoc.cubage
          if (cubage) {
            this.job.densityDoc = NumberUtils.ToFixed2(weight / cubage, 3)
          } else {
            this.job.densityDoc = 0
          }
        }
        break

      case 'cWeight':
        if (cargoDoc) {
          cargoDoc.cWeight = isNaN(cargoDoc.cWeight) ? 0 : JobUtils.calcChargeWeight(cargoDoc.weight, cargoDoc.cubage, true, this.cWeightIsCeil)
          cargoDoc.cWeight = isNaN(cargoDoc.cWeight) ? 0 : cargoDoc.cWeight
        }
        break
      default :
        break
    }
    await this.getTotal()
  }
  //
  async getTotal() {
    this.view.iataPrice = await JobUtils.queryIataPriceCarrier(this.job, this.view.iataPrice)
    this.getRateAndTotal(this.view.iataPrice)
  }
  //
  getRateAndTotal(iataPrice = null) {
    const cargoDoc = this.view.cargoDoc
    if (cargoDoc) {
      if (iataPrice) {
        const level = new IataPrice(iataPrice).getPriceRange(cargoDoc.cWeight)
        cargoDoc.rateCharge = NumberUtils.formatNumber(level, 2)
        if (cargoDoc.rateClass === 'M') {
          cargoDoc.cTotal = cargoDoc.rateCharge
        } else {
          const t = Math.max(iataPrice.levelM, level * cargoDoc.cWeight)
          cargoDoc.cTotal = NumberUtils.formatNumber(t, 2)
        }
        const t = level * cargoDoc.cWeight
        if (t < iataPrice.levelM) {
          cargoDoc.rateClass = 'M'
          cargoDoc.cTotal = cargoDoc.rateCharge
        } else {
          if (cargoDoc.cWeight >= 0 && cargoDoc.cWeight < 45) {
            cargoDoc.rateClass = 'N'
          } else if (cargoDoc.cWeight >= 45) {
            cargoDoc.rateClass = 'Q'
          }
          cargoDoc.cTotal = NumberUtils.formatNumber(level * cargoDoc.cWeight, 2)
        }
      }
    }
  }
  // 航空公司
  carrierChangeHandler(value) {
    const job = this.job
    job.carrierId = value
    this.loadAirlineDetail()
    this.syncDocHandlingInfo()
  }

  /**
   * 改变航空公司的带出逻辑
   */
  airlineCompanyChange(value) {
    if (this.view.$refs.mawbNoInput && value && !this.job.express && Number(this.config.get('AEAllowInputMBL')) === 1) {
      let flg = false
      const company = getObjectByCache(basicCacheKeys.basic_data_Company, 'cmpIdx', value)
      if (company) {
        const airline = getObjectByCache(basicCacheKeys.basic_data_Airline, 'companyUuid', company.uuid)
        if (airline && airline.mawbprefix) {
          this.job.mbl = airline.mawbprefix + this.view.$refs.mawbNoInput.mawbNo
          flg = true
        }
      }
      this.view.$refs.mawbNoInput.splitMbl(this.job.mbl, flg)
    }
  }
  // 加载航线详情
  async loadAirlineDetail() {
    const carrier = await Company.getCompanyById(this.job.carrierId)
    if (carrier) {
      this.updateCarrierBy(carrier.shortName)
      await new Company(carrier).getAirlineDetail()
      this.loadMAWBInfo2(carrier.airlineDetail)
    } else {
      this.updateCarrierBy('')
    }
  }
  updateCarrierBy(shortName) {
    const cargoDoc = this.view.cargoDoc
    if (cargoDoc && cargoDoc.state < 2) {
      cargoDoc.carrierBy = shortName
    }
  }
  // 加载主单详情
  async loadMAWBInfo2(airlineDetail) {
    if (airlineDetail) {
      const mAWBInfo = await new AirLine(airlineDetail).getMAWBInfo()
      if (mAWBInfo && mAWBInfo.length > 0) {
        for (const info of mAWBInfo) {
          if (this.job.opOffice === info.branchId) {
            this.view.cargoDoc.accountCode = info.accountNo
            this.view.cargoDoc.accountingInfo = info.AccountInfo
            // this.view.cargoDoc.handingInfo = info.HandingInfo
            this.view.cargoDoc.iataCode = info.IATACode
            break
          }
        }
      }
    }
  }
  // 主单运费条款
  paymentTermMBLChangeHandler(data) {
    this.job.paymentTermMBL = data.value
    if (this.view.cargoDoc) {
      this.changeFreightTerm(this.view.cargoDoc, this.job.paymentTermMBL)
    }
  }
  // 主单分单运费条款改变，对应的币种等都要相应改动
  changeFreightTerm(awbDoc, keyValue) {
    if (keyValue === 'CCBYPP') {
      awbDoc.currency = 'USD'
      awbDoc.WtVal = AirExportConstants.CC
      awbDoc.other = AirExportConstants.PP
    } else {
      awbDoc.WtVal = keyValue
      awbDoc.other = keyValue
      // 初次保存时才加个默认值，不然复制时修改的都被覆盖了
      if (!awbDoc.uuid && !awbDoc.currency) {
        if (keyValue === AirExportConstants.CC) {
          awbDoc.currency = 'USD'
        } else if (keyValue === AirExportConstants.PP) {
          if (CargoDocConsts.MAWB === awbDoc.docType) {
            awbDoc.currency = RateUtil.localCurrencyByOffice2()
            awbDoc.currency = awbDoc.currency === 'RMB' ? 'CNY' : awbDoc.currency
          } else {
            awbDoc.currency = 'CNY'
          }
        }
      }
    }
  }
  // 更新按扭状态
  checkButtonSate() {
    if (this.view.viewStatus) return
    if (this.job.bookingTerm === BookingTerm.DB_BOOKING_TYPE.code) {
      this.view.selectBtnEnable = this.job.mbl
      this.view.mblEnable = true
      /**
       * 1–友邦模式，当订舱性质=自订舱时，输入框置灰，只能通过选择列表主单号。否则可自由编辑，可手动也可列表选择
       */
      if (Number(this.config.get('EditMawblNoMode')) === 1) {
        this.view.selectBtnEnable = true
      }
    } else {
      this.view.selectBtnEnable = true
      this.view.mblEnable = Number(this.config.get('AEAllowInputMBL')) === 1
      /**
       * 1–友邦模式，当订舱性质=自订舱时，输入框置灰，只能通过选择列表主单号。否则可自由编辑，可手动也可列表选择
       */
      if (Number(this.config.get('EditMawblNoMode')) === 1 && this.job.bookingTerm === BookingTerm.SB_BOOKING_TYPE.code) {
        this.view.mblEnable = false
      }
    }
    this.view.selectMawbDialog.btnName = this.job.mbl ? this.view.$t('SeaExport.Separate') : this.view.$t('SeaExport.PleaseSelect')
  }
  slacChangeHandler() {
    const job = this.job
    if (!job) return
    const slac = job.slac
    const mawbDoc = this.view.cargoDoc
    if (mawbDoc) {
      mawbDoc.slac = slac
    }
  }
  // 单证
  async dcChangeHandler(data) {
    const job = this.job
    job.dc = data.value
    job.dcDepartment = 0
    job.dcOffice = 0
    if (data.value) {
      const offices = await User.getUserDepartmentOffices('role', 'doc', data.value)
      if (offices && offices.length > 1) {
        for (const item of offices) {
          if (item.officeId === $store.getters.currentOfficeId) {
            const office = await Office.getOfficeById(item.officeId)
            job.dcOffice = office ? office.officeId : 0
            job.dcDepartment = item.departmentId
            break
          }
        }
      } else {
        const user = new User(data)
        const dep = await user.getDefaultDepartment('role', 'doc')
        job.dcDepartment = dep ? dep.departmentId : 0
        const office = dep ? await Office.getOfficeByUuid(dep.officeUuid) : null
        job.dcOffice = office ? office.officeId : 0
      }
    } else {
      job.dc = 0
      job.dcDepartment = 0
      job.dcOffice = 0
    }
  }
  // 销售部门修改后，调整分公司信息
  async salesDepartmentChargeHandler(data) {
    const job = this.job
    job.salesDepartment = data.value
    if (job.salesDepartment > 0) {
      const office = await Office.getOfficeByUuid(data.officeUuid)
      if (office && job.salesOffice !== office.officeId) {
        job.salesOffice = office.officeId
        this.loadCompanyOffice()
      }
    }
  }
  // 操作
  async opChangeHandler(data) {
    const job = this.job
    job.op = data.value
    job.opDepartment = 0
    if (data.value) {
      const user = new User(data)
      if (user.defaultDepId && user.defaultOfficeId && user.defaultOfficeId === job.opOffice) {
        job.opDepartment = user.defaultDepId
      } else {
        if (job.opOffice > 0) {
          user.getUserDefaultDepartmentByOffice('role', 'op', job.opOffice).then(dep => {
            job.opDepartment = dep ? dep.departmentId : 0
          })
        } else {
          user.getDefaultDepartment('role', 'op', job.opOffice).then(dep => {
            job.opDepartment = dep ? dep.departmentId : 0
          })
        }
      }
    }
  }
  // 客户修改
  async csrChangeHandler(data) {
    const job = this.job
    job.csr = data.value
    job.csrDepartment = 0
    job.csrOffice = 0
    if (data.value) {
      if (data.defaultDepId && data.defaultOfficeId && job.opOffice === data.defaultOfficeId) {
        job.csrOffice = data.defaultOfficeId
        job.csrDepartment = data.defaultDepId
      } else {
        const offices = await User.getUserDepartmentOffices('role', 'csr', data.value)
        if (offices && offices.length > 1) {
          for (const item of offices) {
            if (item.officeId === $store.getters.currentOfficeId) {
              const office = await Office.getOfficeById(item.officeId)
              job.csrOffice = office ? office.officeId : 0
              job.csrDepartment = item.departmentId
              break
            }
          }
        } else {
          const user = new User(data)
          const dep = await user.getDefaultDepartment('role', 'csr')
          if (dep) {
            job.csrDepartment = dep.departmentId
            const office = await Office.getOfficeByUuid(dep.officeUuid)
            job.csrOffice = office ? office.officeId : 0
          }
        }
      }
    }
  }
  changeMAWB() {
    changeMAWBNo({ 'jobKey': this.job.uuid, 'mawbDetailUuid': this.view.selectedMAWB.uuid, 'mawbNo': this.view.selectedMAWB.mawbNo }).then(res => {
      if (res.data) { // 返回的是最新的Job
        this.job.mbl = res.data.mbl
        this.job.version = res.data.version
        this.checkButtonSate()
      }
    })
  }
  // 同步MAWB信息
  async changeMAWBInfoCommon(datas) {
    if (!datas || datas.length === 0) return
    const mawbDoc = this.view.cargoDoc
    const mawbInfo = datas[0]
    if (mawbInfo) {
      if (mawbDoc && mawbDoc.state < 2) {
        mawbDoc.accountCode = mawbInfo.accountNo
        mawbDoc.accountingInfo = mawbInfo.accountInfo
        // mawbDoc.handingInfo = mawbInfo.handingInfo
        mawbDoc.iataCode = mawbInfo.iataCode
        mawbDoc.notifyLine1 = mawbInfo.carrierAgentCity
        mawbDoc.insuredAmount = mawbInfo.insuredAmount
        mawbDoc.issuedBy = mawbInfo.issuedBy
        if (datas.length === 1) {
          await AirExportUtils.fillMAWBInfoOtherCharge(this.job, mawbDoc, mawbInfo.mawbInfoOtherCharge)
        }
      }
    }
  }
  // 同步MAWB信息
  changeMAWBInfoCommonTips(datas) {
    this.$confirm('是否刷新MAWB相关信息？', this.view.$t('common.tips.prompt'), {
      confirmButtonText: this.view.$t('common.btn.ok'),
      cancelButtonText: this.view.$t('common.btn.cancel'),
      type: 'warning'
    }).then(() => {
      if (datas && datas.length > 0) {
        this.changeMAWBInfoCommon(datas)
      } else {
        const mawbDoc = this.view.cargoDoc
        if (mawbDoc && mawbDoc.state < 2) {
          mawbDoc.accountCode = ''
          mawbDoc.accountingInfo = ''
          // mawbDoc.handingInfo = ''
          mawbDoc.IataCode = ''
          mawbDoc.notifyLine1 = ''
          mawbDoc.insuredAmount = ''
          mawbDoc.issuedBy = ''
          mawbDoc.otherCharge = null
        }
      }
    }).catch(() => {
    })
  }
  // 销售修改事件
  async salesChangeHandler(data) {
    const job = this.job
    job.sales = data.value
    job.salesOffice = 0
    this.view.txtSalesOffice = ''
    job.salesDepartment = 0
    if (data.value) {
      if (data.defaultOfficeId) { // 用户设置了默认公司和部门就用默认的
        job.salesOffice = data.defaultOfficeId
        job.salesDepartment = data.defaultDepId
        this.loadCompanyOffice()
      } else {
        const offices = await User.getUserDepartmentOffices('role', 'sales', data.value)
        if (offices && offices.length > 1) {
          for (const item of offices) {
            if (this.branchOfficeCheck || (!this.branchOfficeCheck && item.officeId === $store.getters.currentOfficeId)) {
              job.salesOffice = item.officeId
              job.salesDepartment = item.departmentId
              this.loadCompanyOffice()
              break
            }
          }
        } else {
          const user = new User(data)
          const department = await user.getDefaultDepartment('role', 'sales')
          job.salesDepartment = department ? department.departmentId : 0
          const office = department ? await Office.getOfficeByUuid(department.officeUuid) : null
          if (office) {
            job.salesOffice = office.officeId
          }
          this.loadCompanyOffice()
        }
      }
    }
    this.dispatchChangedSalesEvent(data.userId || 0)
  }
  // 手动选择销售
  dispatchChangedSalesEvent(sales) {
    // var salesEvent:CommonFormEvent = new CommonFormEvent("salesChanged");
    // salesEvent.data = sales;
    // view.dispatchEvent(salesEvent);
  }
  // 分公司调整
  async opOfficeChargeHandler(data) {
    const job = this.job
    job.opOffice = data.value
    if (!job.opOffice) {
      job.opDepartment = 0
    }
    JobUtils.opOfficeChange({ view: this.view, job, modifiedData: this.context.modifiedData })
  }
  // 航线负责人
  async plannerChangeHandler(data) {
    const job = this.job
    job.planner = data.value
    job.plannerDepartment = 0
    job.plannerOffice = 0
    if (data.value) {
      const user = new User(data)
      const dep = await user.getDefaultDepartment('role', 'airline')
      job.plannerDepartment = dep ? dep.departmentId : 0
      const office = dep ? await Office.getOfficeByUuid(dep.officeUuid) : null
      job.plannerOffice = office ? office.officeId : 0
    } else {
      job.planner = 0
      job.plannerDepartment = 0
      job.plannerOffice = 0
    }
  }
  fillModel(submitData = false) {
    const job = this.job
    // CARGO-31455 12835 空运订舱HAWB remake 显示问题
    if (!job || this.view.viewStatus) return
    // 英文品名
    if (this.view.cargoEnglishNameChange || (job.cargoEnglishName && job.cargoEnglishName !== this.view.oldCargoEnglishName)) {
      AirCargoDocUtil.syncCargoEnglishName(job, this.view.cargoDoc, this.airCargoEnglishName, 0)
      this.view.cargoEnglishNameChange = false
      this.view.oldCargoEnglishName = job.cargoEnglishName
    }
    // 唛头
    if (this.view.markChange || (job.mark && job.mark !== this.view.oldMark)) {
      AirCargoDocUtil.syncMark(job, this.view.cargoDoc, this.airCargoMark, 0)
      this.view.markChange = false
      this.view.oldMark = job.mark
    }
  }
  //
  async updateLoading3Code() {
    this.view.loading3Code = ''
    if (this.job.loadingPortCode) {
      const port = await AirPort.getAirportByCode(this.job.loadingPortCode)
      if (port) {
        this.view.loading3Code = port.code
      }
    }
  }
  //
  async updateDestination3Code() {
    this.view.destination3Code = ''
    if (this.job.destinationPortCode) {
      const port = await AirPort.getAirportByCode(this.job.destinationPortCode)
      if (port) {
        this.view.destination3Code = port.code
      }
    }
  }
  // 订舱性质
  async bookingTermChangeHandler(data) {
    const job = this.job
    job.bookingTerm = data.value
    this.checkButtonSate()
  }
  // 自定义岗位字段1
  async userDefinedRoleId1Handler(data) {
    const job = this.job
    job.userDefinedRoleId1 = data.value || 0
    job.userDefinedRoleDept1 = 0
    job.userDefinedRoleOffice1 = 0
    if (data.value) {
      const offices = await User.getUserDepartmentOffices('role', 'userDefinedRole1', data.value)
      if (offices && offices.length > 1) {
        for (const item of offices) {
          if (item.officeId === $store.getters.currentOfficeId) {
            const office = await Office.getOfficeById(item.officeId)
            job.userDefinedRoleOffice1 = office ? office.officeId : 0
            job.userDefinedRoleDept1 = item.departmentId
            break
          }
        }
      } else {
        const user = new User(data)
        const dep = await user.getDefaultDepartment('role', 'userDefinedRole1')
        job.userDefinedRoleDept1 = dep ? dep.departmentId : 0
        const office = dep ? await Office.getOfficeByUuid(dep.officeUuid) : null
        job.userDefinedRoleOffice1 = office ? office.officeId : 0
      }
    }
  }
  // 自定义岗位字段2
  async userDefinedRoleId2Handler(data) {
    const job = this.job
    job.userDefinedRoleId2 = data.value || 0
    job.userDefinedRoleDept2 = 0
    job.userDefinedRoleOffice2 = 0
    if (data.value) {
      const offices = await User.getUserDepartmentOffices('role', 'userDefinedRole2', data.value)
      if (offices && offices.length > 1) {
        for (const item of offices) {
          if (item.officeId === $store.getters.currentOfficeId) {
            const office = await Office.getOfficeById(item.officeId)
            job.userDefinedRoleOffice2 = office ? office.officeId : 0
            job.userDefinedRoleDept2 = item.departmentId
            break
          }
        }
      } else {
        const user = new User(data)
        const dep = await user.getDefaultDepartment('role', 'userDefinedRole2')
        job.userDefinedRoleDept2 = dep ? dep.departmentId : 0
        const office = dep ? await Office.getOfficeByUuid(dep.officeUuid) : null
        job.userDefinedRoleOffice2 = office ? office.officeId : 0
      }
    }
  }
  // 自定义岗位字段3
  async userDefinedRoleId3Handler(fieldData) {
    const value = fieldData.value
    // if (!$store.getters.enableFrontEndPlugin) {
    //   value = fieldData.value
    // }
    const job = this.job
    job.userDefinedRoleId3 = value || 0
    job.userDefinedRoleDept3 = 0
    job.userDefinedRoleOffice3 = 0
    if (value) {
      const offices = await User.getUserDepartmentOffices('role', 'userDefinedRole3', value)
      if (offices && offices.length > 1) {
        for (const item of offices) {
          if (item.officeId === this.context.office.officeId) {
            job.userDefinedRoleDept3 = item.departmentId
            const office = await Office.getOfficeById(item.officeId)
            job.userDefinedRoleOffice3 = office ? office.officeId : 0
            break
          }
        }
      } else {
        const user = new User(fieldData) // !$store.getters.enableFrontEndPlugin ? new User(fieldData) : new User({ value })
        const dep = await user.getDefaultDepartment('role', 'userDefinedRole3')
        job.userDefinedRoleDept3 = dep ? dep.departmentId : 0
        const office = dep ? await Office.getOfficeByUuid(dep.officeUuid) : null
        job.userDefinedRoleOffice3 = office ? office.officeId : 0
      }
    }
  }
  // 自定义岗位字段4
  async userDefinedRoleId4Handler(fieldData) {
    const value = fieldData.value
    // if (!$store.getters.enableFrontEndPlugin) {
    //   value = fieldData.value
    // }
    const job = this.job
    job.userDefinedRoleId4 = value || 0
    job.userDefinedRoleDept4 = 0
    job.userDefinedRoleOffice4 = 0
    if (value) {
      const offices = await User.getUserDepartmentOffices('role', 'userDefinedRole4', value)
      if (offices && offices.length > 1) {
        for (const item of offices) {
          if (item.officeId === this.context.office.officeId) {
            job.userDefinedRoleDept4 = item.departmentId
            const office = await Office.getOfficeById(item.officeId)
            job.userDefinedRoleOffice4 = office ? office.officeId : 0
            break
          }
        }
      } else {
        const user = new User(fieldData) // !$store.getters.enableFrontEndPlugin ? new User(fieldData) : new User({ value })
        const dep = await user.getDefaultDepartment('role', 'userDefinedRole4')
        job.userDefinedRoleDept4 = dep ? dep.departmentId : 0
        const office = dep ? await Office.getOfficeByUuid(dep.officeUuid) : null
        job.userDefinedRoleOffice4 = office ? office.officeId : 0
      }
    }
  }
  // 自定义岗位字段5
  async userDefinedRoleId5Handler(data) {
    const job = this.job
    job.userDefinedRoleId5 = data.value || 0
    job.userDefinedRoleDept5 = 0
    job.userDefinedRoleOffice5 = 0
    if (data.value) {
      const offices = await User.getUserDepartmentOffices('role', 'userDefinedRole5', data.value)
      if (offices && offices.length > 1) {
        for (const item of offices) {
          if (item.officeId === this.context.office.officeId) {
            this.job.userDefinedRoleDept5 = item.departmentId
            const office = await Office.getOfficeById(item.officeId)
            job.userDefinedRoleOffice5 = office ? office.officeId : 0
            break
          }
        }
      } else {
        const user = new User(data)
        const dep = await user.getDefaultDepartment('role', 'userDefinedRole5')
        job.userDefinedRoleDept5 = dep ? dep.departmentId : 0
        const office = dep ? await Office.getOfficeByUuid(dep.officeUuid) : null
        job.userDefinedRoleOffice5 = office ? office.officeId : 0
      }
    }
  }
  // 自定义岗位字段6
  async userDefinedRoleId6Handler(data) {
    const job = this.job
    job.userDefinedRoleId6 = data.value || 0
    job.userDefinedRoleDept6 = 0
    job.userDefinedRoleOffice6 = 0
    if (data.value) {
      const offices = await User.getUserDepartmentOffices('role', 'userDefinedRole6', data.value)
      if (offices && offices.length > 1) {
        for (const item of offices) {
          if (item.officeId === this.context.office.officeId) {
            this.job.userDefinedRoleDept6 = item.departmentId
            const office = await Office.getOfficeById(item.officeId)
            job.userDefinedRoleOffice6 = office ? office.officeId : 0
            break
          }
        }
      } else {
        const user = new User(data)
        const dep = await user.getDefaultDepartment('role', 'userDefinedRole6')
        job.userDefinedRoleDept6 = dep ? dep.departmentId : 0
        const office = dep ? await Office.getOfficeByUuid(dep.officeUuid) : null
        job.userDefinedRoleOffice6 = office ? office.officeId : 0
      }
    }
  }
  // 自定义岗位字段7
  async userDefinedRoleId7Handler(data) {
    const job = this.job
    job.userDefinedRoleId7 = data.value || 0
    job.userDefinedRoleDept7 = 0
    job.userDefinedRoleOffice7 = 0
    if (data.value) {
      const offices = await User.getUserDepartmentOffices('role', 'userDefinedRole7', data.value)
      if (offices && offices.length > 1) {
        for (const item of offices) {
          if (item.officeId === this.context.office.officeId) {
            this.job.userDefinedRoleDept7 = item.departmentId
            const office = await Office.getOfficeById(item.officeId)
            job.userDefinedRoleOffice7 = office ? office.officeId : 0
            break
          }
        }
      } else {
        const user = new User(data)
        const dep = await user.getDefaultDepartment('role', 'userDefinedRole7')
        job.userDefinedRoleDept7 = dep ? dep.departmentId : 0
        const office = dep ? await Office.getOfficeByUuid(dep.officeUuid) : null
        job.userDefinedRoleOffice7 = office ? office.officeId : 0
      }
    }
  }
  // 更改目的港代理或者航空公司或者操作要求需要同步 形式分单
  async syncDocHandlingInfo() {
    const handlingInfoConfig = this.config.get('HandlingInfoConfig')
    const handlingInfoConfigArr = handlingInfoConfig ? handlingInfoConfig.split(',') : ''
    if (!handlingInfoConfigArr) return

    // 合作伙伴航空公司维护的信息
    let handingInfoOne = ''
    if (this.job.carrierId && this.job.carrierId > 0 && handlingInfoConfig.indexOf('1') !== -1) {
      const carrier = await Company.getCompanyById(this.job.carrierId)
      let airline = null
      if (this.view.cargoDoc && this.view.cargoDoc.state < 2) {
        airline = this.view.cargoDoc.carrierBy = !carrier ? '' : carrier.shortName
      }
      if (airline) {
        const info = await queryMAWBInfo({ airline: airline, branchId: $store.getters.currentOfficeId }).then(async res => {
          return (res.data && res.data.length > 0) ? res.data[0] : null
        })
        handingInfoOne = info ? info.handingInfo : ''
      }
    }

    let handingInfoTwo
    if (handlingInfoConfig.indexOf('2') !== -1) {
      // 目的港代理地址
      handingInfoTwo = await AirCargoDocUtil.handingInfoTwoFunc(this.job.destinationAgent, handlingInfoConfig)
    }

    // 将值组装成map
    const map = new Map()
    if (handingInfoOne) map.set('1', handingInfoOne)
    if (handingInfoTwo) map.set('2', handingInfoTwo)

    // 同步逻辑
    let finalStr = ''
    for (const config of handlingInfoConfigArr) {
      const curValue = map.get(config)
      if (finalStr && curValue) finalStr += '\n'
      finalStr += (curValue || '')
    }

    if (this.view.cargoDoc && handlingInfoConfig.indexOf('1') !== -1) this.view.cargoDoc.handingInfo = finalStr
  }

  async cargoSalesChargeHandler(data) {
    const job = this.job
    job.cargoSalesId = data.value || 0
    job.cargoSalesDepartment = 0
    job.cargoSalesOffice = 0
    if (data.value) {
      const offices = await User.getUserDepartmentOffices('role', 'salesOfGoods', data.value)
      if (offices && offices.length > 1) {
        for (const item of offices) {
          if (item.officeId === this.context.office.officeId) {
            const office = await Office.getOfficeById(item.officeId)
            job.cargoSalesOffice = office ? office.officeId : 0
            job.cargoSalesDepartment = item.departmentId
            break
          }
        }
      } else {
        const user = new User(data)
        const department = await user.getDefaultDepartment('role', 'salesOfGoods')
        if (department) {
          job.cargoSalesDepartment = department ? department.departmentId : 0
          const office = department ? await Office.getOfficeByUuid(department.officeUuid) : null
          job.cargoSalesOffice = office ? office.officeId : 0
        }
      }
    }
  }
  // 唛头修改事件
  async markChangeHandler(value) {
    const job = this.job
    if (!job || this.view.viewStatus) return
    this.view.oldMark = job.mark
    job.mark = value
    this.view.showMarkOrCargoEnglishNameDialog = false
    await this.markBlurHandler()
  }
  async markBlurHandler() {
    const job = this.job
    if (!job || this.view.viewStatus || this.view.showMarkOrCargoEnglishNameDialog) return
    if (job.mark && this.airCargoMark && [1, 2].includes(this.airCargoMark)) {
      const oldMark = this.view.oldMark
      if (oldMark !== job.mark) {
        this.view.markChange = true
        AirCargoDocUtil.syncMark(job, this.view.cargoDoc, this.airCargoMark, 0)
      }
    }
  }
  // 英文品名修改事件
  async cargoEnglishNameChangeHandler(value) {
    const job = this.job
    if (!job || this.view.viewStatus) return
    this.view.oldCargoEnglishName = this.job.cargoEnglishName
    job.cargoEnglishName = value
    this.view.showMarkOrCargoEnglishNameDialog = false
    await this.cargoEnglishNameBlurHandler()
  }
  async cargoEnglishNameBlurHandler() {
    const job = this.job
    if (!job || this.view.viewStatus || this.view.showMarkOrCargoEnglishNameDialog) return
    if (job.cargoEnglishName && this.airCargoEnglishName && [1, 2].includes(this.airCargoEnglishName)) {
      const oldCargoEnglishName = this.view.oldCargoEnglishName
      if (oldCargoEnglishName !== job.cargoEnglishName) {
        this.view.cargoEnglishNameChange = true
        AirCargoDocUtil.syncCargoEnglishName(job, this.view.cargoDoc, this.airCargoEnglishName, 0)
      }
    }
  }
  /**
   * 投保
   */
  async toInsure() {
    const payload = {
      jobUuid: this.job.uuid,
      branchId: this.view.$store.getters.currentOfficeId,
      billno: this.job.mbl,
      insureType: 'JOB'
    }
    const continueExec = await JobUtils.openInsure(payload, this.view)
    if (continueExec) {
      // 跳转的key 再货运险列表中使用的是记录的UUID,此处没有生成使用billno替代
      this.view.$router.push({
        name: 'ToInsurePage',
        query: { openNew: true, title: this.view.$t('Insurance.ToInsure') + payload.billno, key: payload.billno },
        params: { insureForm: payload }
      })
    }
  }
}
